module.exports = {
      id: "download-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#download-icon",
      toString: function () {
        return this.url;
      }
    }